<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div>
                    <dx-data-grid style="z-index: 1;"
                                  (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                  id="tabla"
                                  [columnAutoWidth]="true"
                                  [dataSource]="dataTable"
                                  [noDataText]="'Sin Datos'"
                                  [showColumnHeaders]="true"
                                  >
                                  <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>

                        <dxi-column
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <dxi-column
                            dataField="periodoevaluacion"
                            caption="Periodo E360">
                        </dxi-column>
                        <dxi-column
                            dataField="fechalimite"
                            caption="Fecha límite">
                        </dxi-column>
                        <dxi-column
                            dataField="nombre"
                            caption="Persona a evaluar">
                        </dxi-column>
                        <dxi-column
                            dataField="estatus"
                            caption="Estatus">
                        </dxi-column>
                        <dxi-column
                            dataField="relacion"
                            caption="Relación">
                        </dxi-column>
                        <dxi-column
                            dataField="departamento"
                            caption="Departamento">
                        </dxi-column>
                        <dxi-column
                            dataField="puesto"
                            caption="Puesto">
                        </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Imagen"
                            dataField="urlfotografia"
                            cellTemplate="cellImagenes"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <button class="btn boton botonXS"
                                (click)="Formulario(cell.data)">
                                <span > {{'Evaluar'}}</span>
                            </button>
                        </div>
                        <div *dxTemplate="let cellImagenes of 'cellImagenes'">
                            <div class="imagenPerfilevaluacion popup-button" *ngIf="cellImagenes.value">
                                <div class="marcoevaluacion" >
                                    <div class="imagenPanelevaluacion">
                                        <img [src]="cellImagenes.value  | Imagen | async" id="ImagenPerfil" />
                                    </div>
                                </div>
                                <div class="popup">
                                    <div class="row">
                                        <div class="col-lg-12 contorno">
                                            <div class="imagenPerfil">
                                                <div class="marco">
                                                    <div class="imagenPanel">
                                                        <img [src]="cellImagenes.value  | Imagen | async" id="ImagenPerfilmayor">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>

<div #containerEvaluacion></div>
